export const NeonIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4876 2.50135C17.4623 7.48951 17.5329 12.5156 17.4795 17.4987C16.5309 16.7275 15.6549 15.909 14.7123 15.1444C14.089 14.5861 13.4584 14.0361 12.8206 13.4943C12.4269 13.1542 12.0415 12.7776 11.6077 12.4933C11.6502 12.8159 11.6257 13.8056 11.6254 14.173L11.6213 17.5L2.50271 17.496C2.51831 16.8971 2.51555 16.2784 2.51084 15.6786C2.47642 11.2906 2.56258 6.88643 2.5 2.5L17.4876 2.50135ZM4.34431 10.8473C4.34464 12.438 4.36987 14.0976 4.34296 15.684L9.78239 15.68L9.77697 10.7987V9.29843C9.77642 9.05172 9.76027 8.72092 9.78104 8.48219C10.1446 8.69807 10.3469 8.9559 10.6537 9.21479C11.0238 9.52696 11.3845 9.88054 11.7446 10.1916C13.0141 11.2923 14.3318 12.5232 15.6162 13.5766C15.582 12.5323 15.608 11.3762 15.608 10.3184L15.6108 4.31328L4.34296 4.30788L4.34431 10.8473Z"
        fill="#33D69A"
      />
    </svg>
  );
};
